import SingleTemplate from "./SingleTemplate";
export default SingleTemplate;
